/** Render hijacking HOC for inducing loader */

import React from 'react';
import './Loader.css'

export const matLoader = () => (
    <div className="loader-wrapper"><div class="spinner-border"></div></div>
);


const withLoader = (WrappedComponent) => {
    return class Enhancer extends WrappedComponent {
        render() {
            if (this.props.isFetching) {
                return matLoader();
            }
            
            return <WrappedComponent {...this.props}/>
        }

    };
};

export default withLoader;